/*
 * Copyright (c) Nexign, JSC, 2020-2022.
 */
/**
 * Step Select Subscriber Component
 *
 * @author Aleksandr Perkhunov
 * @author Yakov Gushchin
 * @version 1.16.0
 * @since 1.10.0
 */

import { useMemo } from 'react';

import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

import { makeSelectTranslationWizardProductOfferings } from '../../../modules/internationalization/intSelectors';
import { IWizardProductOfferingsTranslation } from '../../../modules/internationalization/types';
import { IRootReducer } from '../../../reducers/rootReducer';
import { stringFormatParams } from '../../../utils/stringFormat';
import { EWizardProductOfferingsSteps } from '../wizardProductOfferingsConstants';
import { makeSelectProductOfferingsMaxSubsForProductActivation } from '../wizardProductOfferingsSelectors';
import ProductSelectSubscribersTable from './ProductSelectSubscribersTable/ProductSelectSubscribersTable';
import {
    ProductSelectSubscribersInfoStyled,
    ProductSelectSubscribersStyled,
} from './styled/StepSelectSubscribersStyled';

type TStepSelectSubscribersProps = IConnectedProps;

const StepSelectSubscribers = (props: TStepSelectSubscribersProps) => {

    const {
        maxSubsForProductActivation,
        translationProductOfferings,
    } = props;

    const stepTranslation = useMemo(() =>
            translationProductOfferings[EWizardProductOfferingsSteps.StepSelectSubscribers],
        [translationProductOfferings]);

    return <ProductSelectSubscribersStyled>
        <ProductSelectSubscribersInfoStyled>
            {stringFormatParams(stepTranslation.info, { maxCount: maxSubsForProductActivation })}
        </ProductSelectSubscribersInfoStyled>

        <ProductSelectSubscribersTable/>
    </ProductSelectSubscribersStyled>;
};

interface IConnectedProps {
    maxSubsForProductActivation: number;
    translationProductOfferings: IWizardProductOfferingsTranslation;
}

const mapStateToProps = createStructuredSelector<IRootReducer, IConnectedProps>({
    maxSubsForProductActivation: makeSelectProductOfferingsMaxSubsForProductActivation(),
    translationProductOfferings: makeSelectTranslationWizardProductOfferings(),
});

export default connect(mapStateToProps)(StepSelectSubscribers);
